// extracted by mini-css-extract-plugin
module.exports = {"component":"FloatingBar_component__ACIkh","content":"FloatingBar_content__gV5CL"};